import { render, staticRenderFns } from "./TemplateRelationDetailsModalItem.vue?vue&type=template&id=1dcb1cbe&scoped=true"
import script from "./TemplateRelationDetailsModalItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateRelationDetailsModalItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TemplateRelationDetailsModalItem.vue?vue&type=style&index=0&id=1dcb1cbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb1cbe",
  null
  
)

export default component.exports